// Mock data for Zago Pallets - Wood Pallet Company

export const heroData = {
  title: "Zago Pallets",
  subtitle: "Soluciones Sustentables en Tarimas de Madera",
  description: "Impulsa tu logística con calidad garantizada. Entrega rápida en Monterrey y compromiso ambiental real.",
  cta: "Solicitar Cotización",
  ctaSecondary: "Nuestros Productos",
  image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/kdedese1_1000132807.jpg"
};

export const servicesData = [
  {
    id: 1,
    title: "Tarimas Recicladas",
    description: "Tarimas de madera reciclada de alta calidad, contribuyendo al medio ambiente y reduciendo costos.",
    icon: "Recycle"
  },
  {
    id: 2,
    title: "Tarimas Nuevas",
    description: "Tarimas nuevas fabricadas con madera de primera calidad, personalizadas según tus necesidades.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Tratamiento HT",
    description: "Tratamiento térmico certificado bajo norma NOM-144 SEMARNAT para exportación internacional según NIMF-15.",
    icon: "Flame"
  },
  {
    id: 4,
    title: "Cajones y Huacales",
    description: "Fabricación de cajones y huacales de madera para almacenamiento y transporte seguro.",
    icon: "Box"
  },
  {
    id: 5,
    title: "Recolección de Desperdicio",
    description: "Servicio de recolección de desperdicio de madera para reciclaje y disposición responsable.",
    icon: "Truck"
  },
  {
    id: 6,
    title: "Asesoría Personalizada",
    description: "Te ayudamos a encontrar la solución perfecta para tus necesidades de embalaje y logística.",
    icon: "Users"
  }
];

export const productsData = [
  {
    id: 1,
    name: "Tarima Reciclada Estándar",
    size: "40\" x 48\" (4 entradas)",
    description: "Tarima de madera recuperada y reacondicionada. Ahorra hasta 45% vs producto nuevo. Solución eco-económica para operaciones de carga ligera-media con capacidad de 600-800 kg.",
    image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/0soivqeu_Gemini_Generated_Image_n1af90n1af90n1af.png",
    category: "reciclada"
  },
  {
    id: 2,
    name: "Tarima Nueva Exportación",
    size: "40\" x 48\" (4 entradas)",
    description: "Tarima nueva con tratamiento HT certificado NOM-144 SEMARNAT. Madera virgen de primera calidad, cumple NIMF-15 internacional. Capacidad de carga 1,000-1,200 kg. Ideal para exportación y operaciones que requieren máxima resistencia.",
    image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/h23k2i7w_Gemini_Generated_Image_krk46tkrk46tkrk4.png",
    category: "nueva"
  },
  {
    id: 4,
    name: "Cajones de Madera",
    size: "Medidas personalizables",
    description: "Cajones con tratamiento HT certificado NOM-144 SEMARNAT. Construcción reforzada con tablas de pino de 3/4\"-1\" de grosor. Diseño personalizable según peso y dimensiones de carga. Ideal para maquinaria, equipos industriales y productos que requieren máxima protección.",
    image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/l5zn9qe5_IMG-20250724-WA0003.jpg",
    category: "cajon"
  },
  {
    id: 6,
    name: "Tarima Personalizada",
    size: "Medidas a solicitud",
    description: "Fabricamos tarimas con las medidas y especificaciones que necesites.",
    image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/txszd899_Gemini_Generated_Image_m47pa4m47pa4m47p.png",
    category: "personalizada"
  }
];

export const galleryData = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/89vuv3sf_IMG-20250519-WA0027.jpg",
    title: "Tarimas Apiladas",
    category: "Almacén"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/fce010fx_IMG-20260302-WA0001.jpg",
    title: "Tarimas de cubo recicladas",
    category: "Viaje de tarimas"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/ssr72h52_1000132807.jpg",
    title: "Tarimas Listas para Envío",
    category: "Producción"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1626459851797-3af317c8f61a",
    title: "Cajones y Huacales",
    category: "Productos"
  },
  {
    id: 6,
    image: "https://images.pexels.com/photos/6364029/pexels-photo-6364029.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Proceso Eco-Friendly",
    category: "Sustentabilidad"
  }
];

export const contactInfo = {
  phone: "+52 81 4130 9653",
  whatsapp: "528141309653",
  email: "ventas.zagopallets@gmail.com",
  address: "Monterrey, Nuevo León, México",
  hours: "Lunes a Viernes: 8:00 AM - 6:00 PM | Sábado: 8:00 AM - 2:00 PM"
};

// Mock function to simulate quote submission
export const submitQuoteRequest = async (quoteData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Quote request submitted:", quoteData);
      resolve({
        success: true,
        message: "Cotización enviada exitosamente. Nos pondremos en contacto pronto.",
        quoteId: `ZP-${Date.now()}`
      });
    }, 1000);
  });
};

// Mock function to simulate contact form submission
export const submitContactForm = async (contactData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", contactData);
      resolve({
        success: true,
        message: "Mensaje enviado exitosamente. Te contactaremos pronto."
      });
    }, 1000);
  });
};
